import { Box, Skeleton, Stack, Typography } from '@mui/material';
import type { JSX } from 'react';
import { useDelayedFlag } from '../utils/useDelayedFlag';

interface LoadingStateProps {
  readonly loading: boolean;
  /** Anhang A: der verbindliche Ladetext je Bildschirm, z.B. "Dashboard wird geladen …". */
  readonly label: string;
  readonly children: JSX.Element;
}

/** Zeigt `children` sofort; blendet erst nach 150ms Skeleton + Ladetext ein, falls `loading` weiterhin gilt. */
export function LoadingState({ loading, label, children }: LoadingStateProps): JSX.Element {
  const showSkeleton = useDelayedFlag(loading);

  if (!loading) {
    return children;
  }

  if (!showSkeleton) {
    return <Box data-testid="loading-state-quiet" />;
  }

  return (
    <Stack spacing={1.5} data-testid="loading-state" aria-live="polite" aria-busy="true">
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Skeleton variant="rounded" height={32} />
      <Skeleton variant="rounded" height={120} />
      <Skeleton variant="rounded" height={120} />
    </Stack>
  );
}
